// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"style_footerContainer__2v0O5","mainContainer":"style_mainContainer__2U24y"};